// extracted by mini-css-extract-plugin
module.exports = {"cls1":"BlankSlate-BlankSlateAction-module--cls1--36rv1","cls2":"BlankSlate-BlankSlateAction-module--cls2--15oyT BlankSlate-BlankSlateAction-module--cls1--36rv1 my-4"};